import { yupResolver } from '@hookform/resolvers/yup';
import { ChevronLeftIcon, EnterIcon } from '@radix-ui/react-icons';
import { Box, Button, Card, Flex, Select, Spinner, Text } from '@radix-ui/themes';
import { Controller, useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import SelectComponent from '../../components/inputs/Select/SelectComponent';
import TextFieldComponent from '../../components/inputs/Textfield/TextfieldComponent';
import { useGetFacultiesQuery } from '../../hooks/useGetFacultiesQuery';
import { routes } from '../../routes';
import { createDepartament } from '../../services/school/departament/createDepartament';
import { DepartamentType } from '../../types/Departament';
import { CreateDepartamentFormValidation } from './CreateDepartamentFormValidation';
import TextAreaFieldComponent from '../../components/inputs/TextAreafield/TextAreafieldComponent';
import { useGetUniversitiesQuery } from '../../hooks/useGetUniversitiesQuery';
import { provinces } from '../../utils/codes';



export const CreateDepartament = () => {
  const navigate = useNavigate();
  const mutation = useMutation({ mutationFn: createDepartament, mutationKey: 'createDepartament' });

  const { control, setValue,getValues, handleSubmit, formState: { errors } } = useForm<DepartamentType>
    (
      {
        resolver: yupResolver(CreateDepartamentFormValidation),
        defaultValues: {
          description: '',
          idFaculty: ''
        },
        mode: 'onBlur',
        reValidateMode: 'onBlur',
        shouldUseNativeValidation: false,
      }
    );
    const { data:universities, isLoading: isLoadingUniversities, isError: errorUniversities, refetch: refetchUniversities } = useGetUniversitiesQuery({ PageNumber: 1, PageSize: 400 });
    const { data: faculties, isLoading: isLoadingFaculties, isError: errorFaculties, refetch:refetchFaculties } = useGetFacultiesQuery({ PageNumber: 1, PageSize: 400, IdUniversity:getValues('idUniversity') });
  
  const onSubmit = handleSubmit(async (data) => {
    try {
      const result = await mutation.mutateAsync(data);
      if (result) {
        toast.success("Departamento criado com sucesso!");
        navigate(routes.departaments);
      }
    } catch (err: any) {
      toast.error(`${mutation.error ?? err?.message}`);
    }
  });

  const handleProvinceChange = (idProvince: string) => {
    setValue('idProvince', idProvince);
    // refreshProvinces();
  };
  const handleUniversityChange = (id: string) => {
    setValue('idUniversity', id);
    setValue('idFaculty', '');
    refetchFaculties();
  };

  const handleBack = () => {
    navigate(routes.departaments);
  }
  return (

    <form onSubmit={onSubmit} noValidate>
      <Card size='1'>
        <Flex direction='column' gap='4'>
          <TextFieldComponent name="description" label='Departamento' control={control} errors={errors} fieldProps={{ placeholder: 'Nome do Departamento' }} required={true}/>
          <SelectComponent
            name="idUniversity"
            label="Instituição de Ensino Superior"
            control={control}
            errors={errors}
            style={{ width: '100%' }}
            options={universities?.items.map(u => ({
              value: u.id ?? "",
              label: u.description ?? ""
            }))}
            itemsLoading={isLoadingUniversities}
            itemsError={errorUniversities}
            onSelect={handleUniversityChange}
            required={true}
          />
          <SelectComponent name="idFaculty" label='Unidade orgânica' control={control} errors={errors} style={{ width: '100%' }}
            options={faculties?.items.map(faculty => ({
              value: faculty.id ?? "",
              label: faculty.description ?? ""
            }))}
            required={true}
          />

          <SelectComponent
            name="province"
            label="Provincia"
            required={true}
            control={control}
            errors={errors}
            style={{ width: '100%' }}
            options={provinces?.map(u => ({
              value: u.id ?? "",
              label: u.description ?? ""
            }))}
          />
          <TextAreaFieldComponent name="address" label="Endereço" control={control} errors={errors} fieldProps={{ placeholder: 'Endereço' }} />

          <Flex direction='row' gap='4' style={{ alignSelf: 'end' }}>
            <Button type="button" variant="soft" color="gray" onClick={handleBack} disabled={mutation.isLoading}>
              <ChevronLeftIcon /> Voltar
            </Button>
            <Button type="submit" disabled={mutation.isLoading} variant='surface'  >
              {mutation.isLoading ? <Spinner loading> <EnterIcon /></Spinner> : <EnterIcon />}
              Registar
            </Button>
          </Flex>
        </Flex>
      </Card>
    </form>
  );
}